import React, { useState, useEffect, useContext } from "react";
import { Chart } from "react-google-charts";

import { integral_renovados } from "../../services/api";

import './detalhamento_bolsa.css';

const Detalhamento_integral_renovados = (props) => {

    const [data2, setData2] = useState([]);

    const perfil = JSON.parse(localStorage.getItem("perfil"));

    const meu_perfil = perfil[0].perfil;

    const unidades = ['', 'Bento Ribeiro', 'Madureira', 'Santa Cruz', 'Cascadura', 'Taquara', 'Nilopolis', 'Nova Iguaçu', '', 'Seropédica', 'Barra da Tijuca', 'Campo Grande', 'Centro de Excelência', 'Mangueira', 'Maricá', 'Ilha do Governador', 'Freguesia', 'Recreio dos Bandeirantes']

    let data_inicio = props.di;
    let data_fim = props.df;

    const fetchData = async () => {
        try {
            const response = await integral_renovados(data_inicio, data_fim);
            console.log("response integral", response)
            setData2(response);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        console.log("B")
        fetchData();
    }, [data_inicio, data_fim]);

    const convertSegmento = (seg) => {
        switch (seg) {
            case '0-1':
                return 'Mat 1';
            case '0-2':
                return 'Mat 2';
            case '0-3':
                return 'Pré 1';
            case '0-4':
                return 'Pré 2';
            case '1-1':
                return '1º Fund I';
            case '1-2':
                return '2º Fund I';
            case '1-3':
                return '3º Fund I';
            case '1-4':
                return '4º Fund I';
            case '1-5':
                return '5º Fund I';
            case '1-6':
                return '6º Fund II';
            case '1-7':
                return '7º Fund II';
            case '1-8':
                return '8º Fund II';
            case '1-9':
                return '9º Fund II';
            case '2-1':
                return '1ª Médio';
            case '2-2':
                return '2ª Médio';
            case '2-3':
                return '3ª Médio';
            default:
                return seg;
        }
    };

    let chartDataDet = [];

    function formatarMoeda(valor) {
        // Use o Intl.NumberFormat para formatar o valor para o formato monetário
        const formatoMoeda = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        });

        return formatoMoeda.format(valor);
    }

    let total = []
    for (var i = 0; i < 17; i++) {
        total.push(0);
    }
    // NOVO: Variável para guardar a soma ponderada dos descontos
    let somaPonderadaDesconto = 0;

    if (typeof data2 !== 'undefined') {
        chartDataDet = data2.map((item, index) => {
            const row = [convertSegmento(item.seg)];
            total[0] = "Total"
            row.push(item.bolsa_0 || 0);
            total[1] = total[1] + parseInt(item.bolsa_0)
            row.push(item.bolsa_5 || 0);
            total[2] = total[2] + parseInt(item.bolsa_5)
            row.push(item.bolsa_10 || 0);
            total[3] = total[3] + parseInt(item.bolsa_10)
            row.push(item.bolsa_15 || 0);
            total[4] = total[4] + parseInt(item.bolsa_15)
            row.push(item.bolsa_20 || 0);
            total[5] = total[5] + parseInt(item.bolsa_20)
            row.push(item.bolsa_25 || 0);
            total[6] = total[6] + parseInt(item.bolsa_25)
            row.push(item.bolsa_30 || 0);
            total[7] = total[7] + parseInt(item.bolsa_30)
            row.push(item.bolsa_35 || 0);
            total[8] = total[8] + parseInt(item.bolsa_35)
            row.push(item.bolsa_40 || 0);
            total[9] = total[9] + parseInt(item.bolsa_40)
            row.push(item.bolsa_45 || 0);
            total[10] = total[10] + parseInt(item.bolsa_45)
            row.push(item.bolsa_50 || 0);
            total[11] = total[11] + parseInt(item.bolsa_50)
            row.push(item.bolsa_55 || 0);
            total[12] = total[12] + parseInt(item.bolsa_55)
            row.push(item.bolsa_100 || 0);
            total[13] = total[13] + parseInt(item.bolsa_100)
            row.push(item.total_matriculas || 0);
            total[14] = total[14] + parseFloat(item.total_matriculas)
            row.push(parseFloat(item.desconto_medio));
            total[15] = total[15] + parseFloat(item.desconto_medio)
            row.push(parseFloat(item.anuidade_esperada_com_desconto));
            total[16] = total[16] + parseFloat(item.anuidade_esperada_com_desconto)
            somaPonderadaDesconto += (parseFloat(item.desconto_medio) * parseFloat(item.total_matriculas));
            return row;
        });


    };
    // ALTERADO: Cálculo final da média ponderada
    // Verifica se o total de alunos (total[14]) é maior que zero para evitar divisão por zero
    if (total[14] > 0) {
        total[15] = somaPonderadaDesconto / total[14];
    } else {
        total[15] = 0; // Caso não haja alunos, o desconto médio é 0
    }


    chartDataDet.push(total);

    console.log("Total", total);

    const options = {
        allowHtml: true,

    };
    let formatters = [
        {
            type: "NumberFormat",
            column: 16,
            options: {
                prefix: "R$",
                negativeColor: "red",
                negativeParens: true,
            },
        },
        {
            type: "NumberFormat",
            column: 15,
            options: {
                suffix: "%",
                negativeColor: "red",
                negativeParens: true,
            },
        },
        {
            type: "ColorFormat",
            column: 15,
            ranges: [
                [0, 25, "white", "green"],
                [25, 36, "white", "orange"],
                [36, 50, "white", "red"],
                [50, 100, "white", "darkred"],
            ],
        },

    ];

    chartDataDet.unshift(['Segmento', '0%', '5%', '10%', '15%', '20%', '25%', '30%', '35%', '40%', '45%', '50%', '51% ~ 99%', '100%', 'Alunos', 'Desconto Médio', 'Faturamento Esperado']);


    if (meu_perfil.startsWith("GESTOR") || meu_perfil.startsWith("DIRETOR")) {

        return (
            <div className="bolsas">
                <h4>
                    Detalhamento do integral - SMREDE 2027 - Renovados

                </h4>
                <Chart
                    chartType="Table"
                    version="current"
                    width="100%"
                    data={chartDataDet}
                    options={options}
                    formatters={formatters}
                />
            </div>
        );
    } else {
        return (
            <div className="vazio">

            </div>
        )
    }

};
export default Detalhamento_integral_renovados;